/* ============================================================
   MDP (Matchday Page) Base Script
   複数セクションから共通で呼び出す軽量ユーティリティ
   ============================================================ */
(function () {
  if (window.__mdpBaseInit) return;
  window.__mdpBaseInit = true;

  // ---- Scroll Reveal ----
  function initReveal() {
    var targets = document.querySelectorAll('.mdp-reveal:not(.is-visible)');
    if (!targets.length) return;
    if (!('IntersectionObserver' in window)) {
      targets.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -8% 0px' }
    );
    targets.forEach(function (el) { io.observe(el); });
  }

  // ---- Content Nav Scrollspy ----
  function initScrollspy() {
    var nav = document.querySelector('[data-mdp-nav]');
    if (!nav) return;
    var links = Array.prototype.slice.call(nav.querySelectorAll('[data-mdp-nav-link]'));
    if (!links.length) return;
    var sections = links
      .map(function (link) {
        var id = link.getAttribute('href').replace('#', '');
        return document.getElementById(id);
      })
      .filter(Boolean);
    if (!sections.length || !('IntersectionObserver' in window)) return;

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          var id = entry.target.id;
          var link = nav.querySelector('[data-mdp-nav-link][href="#' + id + '"]');
          if (!link) return;
          if (entry.isIntersecting) {
            links.forEach(function (l) { l.classList.remove('is-active'); });
            link.classList.add('is-active');
          }
        });
      },
      { rootMargin: '-40% 0px -50% 0px', threshold: 0 }
    );
    sections.forEach(function (s) { io.observe(s); });
  }

  // ---- Countdown (scoreboard) ----
  function initCountdown() {
    var boards = document.querySelectorAll('[data-mdp-countdown]');
    boards.forEach(function (board) {
      var target = new Date(board.getAttribute('data-mdp-countdown')).getTime();
      if (isNaN(target)) { board.style.display = 'none'; return; }

      var elD = board.querySelector('[data-cd-d]');
      var elH = board.querySelector('[data-cd-h]');
      var elM = board.querySelector('[data-cd-m]');
      var elS = board.querySelector('[data-cd-s]');
      var liveLabel = board.getAttribute('data-mdp-countdown-live');

      function pad(n) { return String(n).padStart(2, '0'); }

      function tick() {
        var diff = target - Date.now();
        if (diff <= 0) {
          if (liveLabel) {
            board.innerHTML = '<span class="mdp-countdown__live">' + liveLabel + '</span>';
          } else {
            board.style.display = 'none';
          }
          clearInterval(timer);
          return;
        }
        var d = Math.floor(diff / 86400000);
        var h = Math.floor((diff % 86400000) / 3600000);
        var m = Math.floor((diff % 3600000) / 60000);
        var s = Math.floor((diff % 60000) / 1000);
        if (elD) elD.textContent = pad(d);
        if (elH) elH.textContent = pad(h);
        if (elM) elM.textContent = pad(m);
        if (elS) elS.textContent = pad(s);
      }
      tick();
      var timer = setInterval(tick, 1000);
    });
  }

  // ---- Section-level accordion label swap (timetable "続きを見る" etc.) ----
  function initSectionToggleLabels() {
    var groups = document.querySelectorAll('.mdp-timetable__more');
    groups.forEach(function (details) {
      var label = details.querySelector('[data-label-open]');
      if (!label || label.__mdpBound) return;
      label.__mdpBound = true;
      details.addEventListener('toggle', function () {
        label.textContent = details.open
          ? label.getAttribute('data-label-open')
          : label.getAttribute('data-label-closed');
      });
    });
  }

  // ---- Dialog popups (indoor shop detail etc.) ----
  function initDialogs() {
    document.querySelectorAll('[data-mdp-dialog-target]').forEach(function (btn) {
      if (btn.__mdpBound) return;
      btn.__mdpBound = true;
      btn.addEventListener('click', function () {
        var id = btn.getAttribute('data-mdp-dialog-target');
        var dialog = document.getElementById(id);
        if (dialog && typeof dialog.showModal === 'function') {
          dialog.showModal();
        }
      });
    });

    document.querySelectorAll('dialog').forEach(function (dialog) {
      if (dialog.__mdpBound) return;
      dialog.__mdpBound = true;
      dialog.addEventListener('click', function (e) {
        if (e.target === dialog) dialog.close();
      });
      var closeBtn = dialog.querySelector('[data-mdp-dialog-close]');
      if (closeBtn) {
        closeBtn.addEventListener('click', function () { dialog.close(); });
      }
    });
  }

  // ---- Single-column carousel (venue map etc.) ----
  function initCarousels() {
    document.querySelectorAll('[data-mdp-carousel]').forEach(function (root) {
      if (root.__mdpBound) return;
      root.__mdpBound = true;

      var track = root.querySelector('[data-mdp-carousel-track]');
      var slides = Array.prototype.slice.call(root.querySelectorAll('[data-mdp-carousel-slide]'));
      var prevBtn = root.querySelector('[data-mdp-carousel-prev]');
      var nextBtn = root.querySelector('[data-mdp-carousel-next]');
      var dots = Array.prototype.slice.call(root.querySelectorAll('[data-mdp-carousel-dot]'));
      if (!track || !slides.length) return;

      function currentIndex() {
        var scrollLeft = track.scrollLeft;
        var width = track.clientWidth || 1;
        return Math.round(scrollLeft / width);
      }

      function goTo(index) {
        var clamped = Math.max(0, Math.min(index, slides.length - 1));
        track.scrollTo({ left: clamped * track.clientWidth, behavior: 'smooth' });
      }

      function updateDots() {
        if (!dots.length) return;
        var idx = currentIndex();
        dots.forEach(function (dot, i) {
          dot.classList.toggle('is-active', i === idx);
        });
      }

      if (prevBtn) prevBtn.addEventListener('click', function () { goTo(currentIndex() - 1); });
      if (nextBtn) nextBtn.addEventListener('click', function () { goTo(currentIndex() + 1); });
      dots.forEach(function (dot, i) {
        dot.addEventListener('click', function () { goTo(i); });
      });

      track.addEventListener('scroll', function () {
        window.clearTimeout(track.__mdpScrollTimer);
        track.__mdpScrollTimer = window.setTimeout(updateDots, 80);
      });

      updateDots();
    });
  }

  // ---- Sticky nav fallback（テーマ側の overflow 制約でCSS position:sticky が
  //      効かない場合でも確実に追従させるためのJSフォールバック） ----
  function initStickyNavFallback() {
    var wrap = document.querySelector('[data-mdp-nav-wrap]');
    var nav = document.querySelector('[data-mdp-nav]');
    var sentinel = document.querySelector('[data-mdp-nav-sentinel]');
    if (!wrap || !nav || !sentinel) return;
    if (nav.getAttribute('data-mdp-nav-sticky') === 'false') return;
    if (wrap.__mdpBound) return;
    wrap.__mdpBound = true;

    function pin() {
      if (nav.classList.contains('is-pinned')) return;
      wrap.style.height = nav.getBoundingClientRect().height + 'px';
      nav.classList.add('is-pinned');
    }
    function unpin() {
      if (!nav.classList.contains('is-pinned')) return;
      nav.classList.remove('is-pinned');
      wrap.style.height = '';
    }

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              unpin();
            } else if (entry.boundingClientRect.top < 0) {
              pin();
            }
          });
        },
        { threshold: 0 }
      );
      io.observe(sentinel);
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    initReveal();
    initScrollspy();
    initCountdown();
    initSectionToggleLabels();
    initDialogs();
    initCarousels();
    initStickyNavFallback();
  });

  // Theme editor: re-init when a section is added/re-rendered
  document.addEventListener('shopify:section:load', function () {
    initReveal();
    initScrollspy();
    initCountdown();
    initSectionToggleLabels();
    initDialogs();
    initCarousels();
    initStickyNavFallback();
  });
})();
